
import React from 'react';
import ProductsList from '../components/ProductsList';

export default function ProductsPage() {
  return (
    <ProductsList endpoint="/api/v1/products" />
  );
}
